import VueRouter from 'vue-router'
import Page from '../components/pagesComponents/Page'
import Index from '../components/childComponents/Index'

import About from '../components/childComponents/About'
import Company from '../components/childComponents/about/Company'
import Research from '../components/childComponents/about/Research'



import Contact from '../components/childComponents/Contact'

import Service from '../components/childComponents/Service'

import Products from '../components/childComponents/Products'
import Product1 from '../components/childComponents/products/Product1'
import Product2 from '../components/childComponents/products/Product2'
import Product3 from '../components/childComponents/products/Product3'
import Product4 from '../components/childComponents/products/Product4'

const router = new VueRouter({
    routes: [{
        path: '/',
        component: Page,
        children: [{
                path: 'index',
                component: Index
            },
            {
                path: 'about',
                component: About,
                children: [{
                        path: 'company',
                        component: Company
                    },
                    {
                        path: 'research',
                        component: Research
                    }
                ]
            },
            {
                path: 'products',
                component: Products,
                children: [{
                        path: 'product1',
                        component: Product1
                    },
                    {
                        path: 'product2',
                        component: Product2
                    },
                    {
                        path: 'product3',
                        component: Product3
                    },
                    {
                        path: 'product4',
                        component: Product4
                    },
                ]
            },
            {
                path: 'contact',
                component: Contact
            },
            {
                path: 'service',
                component: Service
            }
        ]
    }]
})

router.beforeEach((to, from, next) => {
    if (to.path === '/') {
        router.push('/index');
    } else {
        next();
    }
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
export default router